import React, { useState, useContext } from 'react';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import Typography from '@material-ui/core/Typography';
import ImageGridList from 'components/ImageGridList';
import { useHistory } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Popup from './Popup';
import styles from './styles.module.scss';
import { useQuery } from 'react-query';
import * as profileApi from 'api/profile';
import { viewTargetProfile } from 'api/member';
import Message from '../../components/Message';
import { AuthContext } from '../../context/AuthContext';

const filter = { pageIndex: 1, pageSize: 1000 };

function Home() {
  const isClient = typeof window !== 'undefined';
  const authContext = useContext(AuthContext);

  const history = useHistory();
  const scrollRef = React.useRef(null);
  const checkPopupOpen = isClient && localStorage.getItem('popupOpen') === 'true';
  const { data: userList, isLoading } = useQuery(['userList', filter], () => profileApi.getListProfile(filter));
  const [alertmessage, setalertmessage] = useState('');
  const [open, setopen] = useState(false);
  const popups = authContext.popups;

  const cardList = () => {
    return (
      <ImageGridList
        checked={true}
        cards={userList?.data}
        selectCardFunc={(card) => {
          selectCard(card);
        }}
      />
    );
  };

  const selectCard = async (card) => {
    await viewTargetProfile(card.id)
      .then(() => {
        history.push({ pathname: `${process.env.RAZZLE_PUBLIC_URL}/user/` + card.id });
      })
      .catch((e) => {
        setopen(true);
        setalertmessage(e.response?.data?.message);
      });
  };

  const handleClose = () => {
    setopen(false);
    setalertmessage('');
  };

  return (
    <div style={{ overflow: 'auto', height: '100vh' }} ref={scrollRef}>
      {open ? <Message open={open} handleClose={handleClose} alertmessage={alertmessage} /> : null}

      <div id="pageContainer" className={styles.homePage}>
        <div className={styles.topNavContainer}>
          <TopNav name="Home" hasLogo={true} hasHamburger={true} />
        </div>
        {isLoading && filter.pageIndex === 1 ? (
          <div className={styles.loading}>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <div className={styles.cardImage}>
            {!userList?.data?.length ? (
              <React.Fragment>
                <center>
                  <Typography
                    variant="h6"
                    className="font-2"
                    style={{
                      marginTop: 65,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '80vh',
                    }}
                  >
                    {userList?.message}
                  </Typography>
                </center>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {cardList()}
                {
                  // Store Local Storage base on Feedback, when the first authentication  open Popup
                  checkPopupOpen && <Popup popups={popups} />
                }
              </React.Fragment>
            )}
          </div>
        )}
        {isLoading ? null : <Paper className={styles.paper} elevation={0} />}
        <BottomNav />
      </div>
    </div>
  );
}
export default Home;
